export const BASE_URL= 'https://api.themoviedb.org/3';
export const API_KEY= 'fe7618a98c8eaed5bf4a020ddb974602';
export const image_url= 'https://image.tmdb.org/t/p/original'
export const image_w300= 'https://image.tmdb.org/t/p/w300'
export const image_w500= 'https://image.tmdb.org/t/p/w500'
